import React from 'react';
import styles from './onboardingHero.module.css';

const HeroScrollIndicator: React.FC = () => (
  <div className={styles.scrollIndicator} aria-hidden="true">
    <span className={styles.scrollIndicatorDot} />
  </div>
);

export default HeroScrollIndicator;
